export default __webpack_public_path__ + "static/soehne-web-extrafett-748dabacb74a01563db55bf0653451d3.woff2";